import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { styled } from "styled-components";
import { IoLogoGitlab, IoLogoLinkedin } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import Credits from "../screens/Credits";

const Footer = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const linkRef = useRef(null);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") setIsOpen(true);
  };

  return (
    <FooterContainer>
      <HR />
      <SectionContainer>
        {/* Gauche — mentions + copyright */}
        <LeftBlock>
          <MentionsUl>
            <MentionsLi>
              <Link to="/mentions">{t("footer.legal")}</Link>
            </MentionsLi>
            <Divider>|</Divider>
            <MentionsLi>
              <span
                tabIndex={0}
                ref={linkRef}
                onClick={() => setIsOpen(true)}
                onKeyDown={handleKeyDown}
                role="button"
              >
                {t("footer.credits")}
              </span>
              {isOpen && (
                <Credits
                  openModal={isOpen}
                  closeModal={() => setIsOpen(false)}
                />
              )}
            </MentionsLi>
          </MentionsUl>

          <TextCopy>
            &copy; Copyright 2020-2026 — WebSculpt
            Creations&nbsp;•&nbsp;SIRET&nbsp;: 889 890 174 00028
          </TextCopy>
        </LeftBlock>

        {/* Droite — icônes sociales */}
        <SocialBlock>
          <SocialLink
            to="https://gitlab.com/Roxy75"
            rel="noopener noreferrer"
            target="_blank"
            aria-label="GitLab"
          >
            <IoLogoGitlab aria-hidden="true" />
          </SocialLink>
          <SocialLink
            to="https://www.linkedin.com/in/johane-o-07345835/"
            rel="noopener noreferrer"
            target="_blank"
            aria-label="LinkedIn"
          >
            <IoLogoLinkedin aria-hidden="true" />
          </SocialLink>
        </SocialBlock>
      </SectionContainer>
    </FooterContainer>
  );
};

export default Footer;

/* ─── Styles ──────────────────────────────────────────────────────────────── */

const FooterContainer = styled.footer`
  padding-bottom: 1.5rem;
`;

const HR = styled.hr`
  width: 90%;
  margin: 0 auto 1.2rem auto;
  opacity: 0.15;
  border-color: #fafafa;
`;

const SectionContainer = styled.section`
  width: 90%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  @media (max-width: 576px) {
    gap: 0.75rem;
  }
`;

/* ─── Bloc gauche ─────────────────────────────────────────────────────────── */

const LeftBlock = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center; /* texte centré */
  gap: 0.35rem;
`;

const MentionsUl = styled.ul`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
`;

const MentionsLi = styled.li`
  font-size: 0.8rem;
  font-family: "Protest Revolution", sans-serif;

  a,
  span {
    color: #a8a29e;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.2s ease;

    &:hover {
      color: #fafafa;
    }
  }

  @media (min-width: 2400px) {
    font-size: 1.5rem;
  }

  @media (min-width: 1440px) {
    font-size: 1rem;
  }

  @media (max-width: 768px) {
    font-size: 0.7rem;
  }
`;

const Divider = styled.span`
  color: rgba(180, 1, 18, 0.7);
  font-size: 0.75rem;
  user-select: none;
`;

const TextCopy = styled.p`
  font-size: 0.72rem;
  font-family: "Protest Revolution", sans-serif;
  color: #a8a29e;

  @media (min-width: 2400px) {
    font-size: 1.3rem;
  }

  @media (min-width: 1440px) {
    font-size: 0.9rem;
  }

  @media (max-width: 768px) {
    font-size: 0.62rem;
  }
`;

/* ─── Bloc droit — icônes ─────────────────────────────────────────────────── */

const SocialBlock = styled.article`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
`;

const SocialLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  color: #a8a29e;
  font-size: 1.25rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition:
    color 0.2s ease,
    border-color 0.2s ease,
    background 0.2s ease;

  &:hover {
    color: #fafafa;
    border-color: rgba(180, 1, 18, 0.5);
    background: rgba(180, 1, 18, 0.08);
  }

  @media (min-width: 2400px) {
    width: 52px;
    height: 52px;
    font-size: 2rem;
  }

  @media (min-width: 1440px) {
    width: 40px;
    height: 40px;
    font-size: 1.5rem;
  }

  @media (max-width: 768px) {
    width: 30px;
    height: 30px;
    font-size: 1.1rem;
  }
`;
